import Select from 'components/Select'
import React from 'react'
import EventsList from './Components/EventList'
import {
  Container,
  LeftSection,
  RightSection,
  SectionWrapper,
  StyledButton1,
} from './style'

const sortByOption = [
  { label: 'Show All', value: 'showAll' },
  { label: 'Recently Added', value: 'forRecentlyAdded' },
  { label: 'Date-wise', value: 'startDate' },
  { label: 'Registration Events', value: 'forRegisterEvent' },
]

const List = ({
  state,
  handleOccurrenceClick,
  setState,
  fetchEventsList,
  setListDate,
  listDate,
  handleSortByChange,
  handleSingleEventClick,
  handleRegistrationClick,
  studentDetails,
}) => {
  return (
      <SectionWrapper>
        {state.eventStatus == 'DRAFT' ? null : (
          <Container column mTop={'10px'}>
            <LeftSection centerVertically>
              <StyledButton1
                onClick={() => handleOccurrenceClick('UPCOMING')}
                isSelected={state?.occurence == 'UPCOMING'}
                disabled={state?.occurence == 'UPCOMING'}
              >
                Upcoming events
              </StyledButton1>
              <StyledButton1
                onClick={() => handleOccurrenceClick('PAST')}
                isSelected={state?.occurence == 'PAST'}
                disabled={state?.occurence == 'PAST'}
              >
                View all past events
              </StyledButton1>
            </LeftSection>
            <RightSection centerVertically>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-end',
                  gap: '1rem',
                  marginTop: '-38px',
                  position: 'relative',
                  paddingBottom: '30px',
                }}
              >
                <div>Sort by</div>
                <Select
                  style={{ borderRadius: '5px', width: '160px' }}
                  showArrow={true}
                  options={sortByOption}
                  valueParam="value"
                  placeholder="Select"
                  onChange={value => handleSortByChange(value)}
                  showSearch={false}
                  autoClearSearchValue={false}
                  allowClear={false}
                  selectedPlaceId={'sortByEvent'}
                  textFieldHeight={'38px'}
                  boxShadow={'0px 2px 6px 0px rgba(123, 97, 255, 0.15)'}
                  border={'1px solid rgba(214, 219, 247, 1)'}
                  value={state.sort}
                />
              </div>
            </RightSection>
          </Container>
        )}
        <EventsList
          state={state}
          setState={setState}
          fetchEventsList={fetchEventsList}
          setListDate={setListDate}
          listDate={listDate}
          handleSingleEventClick={handleSingleEventClick}
          handleRegistrationClick={handleRegistrationClick}
          studentDetails={studentDetails}
        />
      </SectionWrapper>
  )
}
export default List
